import React from 'react';
import { CardContainer, Icon, Details, Name, Type } from './styles';

export interface ReceivingMethodInfoCardProps {
  icon?: string;
  title?: string;
  subtitle?: React.ReactNode;
  className?: string;
}

const ReceivingMethodInfoCard: React.FC<ReceivingMethodInfoCardProps> = ({
  icon,
  title,
  subtitle,
  className
}) => {
  return (
    <CardContainer className={className}>
      {icon && (
        <Icon>
          <img src={icon} alt="icon" />
        </Icon>
      )}
      <div className="seperation-line"></div>
      <Details>
        <Name>{title}</Name>
        {subtitle && <Type>{subtitle}</Type>}
      </Details>
    </CardContainer>
  );
};

export default ReceivingMethodInfoCard;
